import * as actionTypes from './actionTypes';
import { CreatePasswordModel } from '@app/src/views/Login/createPassword/models/CreatePassword';

interface State {
  data: CreatePasswordModel,
  errorMessage: string,
  isFetching: boolean,
}

const initialState: State = {
  data: {
    code: null,
    data: [],
    message: ''
  },
  errorMessage: '',
  isFetching: false
}

export const createPassword = (state: State = initialState, action): State => {
  switch(action.type) {
    case actionTypes.FETCH_CREATEPASSWORD_REQUEST:
      return {
        ...state,
        errorMessage: '',
        isFetching: true
      };
    case actionTypes.FETCH_CREATEPASSWORD_FAILURE:
      return {
        ...state,
        errorMessage: action.errorMessage,
        isFetching: false
      };
    case actionTypes.FETCH_CREATEPASSWORD_SUCCESS:
      return {
        ...state,
        errorMessage: '',
        data: action.data,
        isFetching: false
      };
    default:
      return state;
  }
}
